import http from './httpService';

export const getPanoramas = () => {
    return http.get(
        `${process.env.REACT_APP_MODELIC_API}/viewer/pano/all_pano`
    );
};

export const uploadPanoramas = (files, config) => {
    return http.post(
        `${process.env.REACT_APP_MODELIC_API}/viewer/pano/upload`,
        files,
        config
    );
};

export const deletePanorama = (name) => {
    return http.delete(
        `${process.env.REACT_APP_MODELIC_API}/viewer/pano/delete?pano_name=${name}`
    );
};

export const getPanorama = (name) => {
    return http.get(
        `${process.env.REACT_APP_MODELIC_API}/viewer/pano/download/${name}`
    );
};
